var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [(_vm.userrole == 3) ? _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "dashboard"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userrole != 3) ? _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "admindashboard"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userrole != 3) ? _c('div', {
    staticClass: "menu_options_mn"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu_options_sub"
  }, [_c('table', {
    staticClass: "table table-responsive"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "menu_data",
    staticStyle: {
      "margin-left": "20px"
    }
  }, _vm._l((_vm.navItem), function(data) {
    return (data.submenu.length == 0) ? _c('div', [(data.ismenu == true) ? _c('div', {
      staticClass: "mlink "
    }, [_c('a', {
      attrs: {
        "href": '#' + data.url
      },
      on: {
        "click": _vm.itemlink
      }
    }, [_c('i', {
      class: data.purl
    }), _vm._v(" " + _vm._s(data.mainmenu))])]) : _vm._e()]) : _vm._e()
  })), _vm._v(" "), _vm._l((_vm.navItem), function(data) {
    return _c('td', {
      staticClass: "menu_data"
    }, [(data.submenu.length > 0 && data.ismenu == true) ? _c('div', [_c('div', {
      staticClass: "topheadv1"
    }, [_c('b', [_c('i', {
      class: data.purl
    }), _vm._v(" " + _vm._s(data.mainmenu))])]), _vm._v(" "), _vm._l((data.submenu), function(submenu) {
      return _c('div', [(submenu.ismenu == true) ? _c('div', {
        staticClass: "mlink"
      }, [(submenu.ismenu == true) ? _c('a', {
        attrs: {
          "href": '#' + submenu.url
        },
        on: {
          "click": _vm.itemlink
        }
      }, [_c('i', {
        class: submenu.purl
      }), _vm._v(" " + _vm._s(submenu.mainmenu))]) : _vm._e()]) : _vm._e()])
    })], 2) : _vm._e()])
  })], 2)])])]), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    staticStyle: {
      "margin-right": "1%"
    },
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/default-img.png",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none",
    staticStyle: {
      "color": "#fff !important"
    }
  }, [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.changepassword
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Change Password")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Logout")])], 2)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "menu_item"
  }, [_vm._v("Actions  "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45d41bfd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 382
// module chunks = 1